import { render, staticRenderFns } from "./ProductOrderSdsPopUp.vue?vue&type=template&id=6c2b2e41&scoped=true&"
import script from "./ProductOrderSdsPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderSdsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderSdsPopUp.vue?vue&type=style&index=0&id=6c2b2e41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b2e41",
  null
  
)

export default component.exports